//React Imports
import React, { useContext, useState } from "react";

import {format, parseISO} from 'date-fns'

//Context Imports
import TradeContext from "../../store/tradeState/tradeContext";

//Component Imports
import TableHeaderSort from "../table-header-sort/table-header-sort";

//Icon Imports
import { FaStickyNote, FaFile } from "react-icons/fa";

//Helper Import
import { numberFormat, handleStatusStyle } from "../../common/helper";
import PropTypes from "prop-types";


//Styles Import
import "./trade-table.css";

const TradeTable = () => {
  const tradeCtx = useContext(TradeContext);
  

  const handleShowTrade = (trade) => {
    tradeCtx.setTrade(trade);
    tradeCtx.setShowTrade(true);
  };

  const handleFileClicked = (trade) => {
    tradeCtx.setTrade(trade);
    tradeCtx.setShowFiles(true);
    tradeCtx.setTradeFiles(trade.trade_documents);
  }

  const handleTradeStatus = (trade) => {
    switch (trade.status) {
      case 'CREATED':
        return (
        <span
          className={`createdTrade statusColumn `}
        >
          Created
        </span>
      )
      case 'BOOKED':
        return (
        <span
          className={`createdTrade statusColumn `}
        >
          Booked
        </span>
      )
      case 'COMPLETED':
        return (
        <span
          className={`completedTrade statusColumn `}
        >
          Completed
        </span>
      )
      case 'CANCELLED':
        return (
        <span
          className={`cancelledTrade statusColumn `}
        >
          Cancelled
        </span>
      )
      case 'AWAITING_DOCUMENTS':
        return (
        <span
          className={`awaitingDocuments statusColumn `}
        >
          Awaiting Documents
        </span>
      )
      case 'AWAITING_AUTHORISATION':
        return (
        <span
          className={`awaitingAuthorisation statusColumn `}
        >
          Awaiting Authorisation
        </span>
      )
      case 'SUBMITTED_TO_BANK':
        return (
        <span
          className={`submittedToBank statusColumn `}
        >
          Submitted to Bank
        </span>
      )
      default:
        return (
        <span
          className={`createdTrade statusColumn `}
        >
          Unknown
        </span>
      )
    }
  };

  const handleCheckAllBookedTrades = (e) => {
    if (e.target.checked) {
      tradeCtx.setAllBookedTradesChecked(true);
      const bookedTrades = tradeCtx.trades.filter(
        (trade) => trade.trade_status === 1
      );
      const bookedTradeIds = bookedTrades.map((trade) => trade.id);
      tradeCtx.setTradeBatch(bookedTradeIds);
    } else {
      tradeCtx.setTradeBatch([]);
      tradeCtx.setAllBookedTradesChecked(false);
    }
  }

  

  return (
    <table className="table table-hover sticky-header modern-table">
      <thead>
        <tr>
          <th style={{ width: "20px" }}>
            <input
              type="checkbox"
              className="checkbox-circle"
              onChange={(e) => handleCheckAllBookedTrades(e)}
              checked={tradeCtx.allBookedTradesChecked}
            />
          </th>
          <th style={{ width: "240px" }}>
            <TableHeaderSort
              header="Customer"
              sortParam="customer__name"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
            />
          </th>
          <th style={{ width: "140px" }}>
            <TableHeaderSort
              header="Bank"
              sortParam="bank__name"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
            />
          </th>
          <th style={{ width: "170px" }}>
            <TableHeaderSort
              header="Trade Number"
              sortParam="trade_reference_number"
              sortData={(data) => {
                tradeCtx.setSortArray([...data]);
              }}
              sortArray={tradeCtx.sortArray}
            />
          </th>
          <th style={{ width: "140px" }}>
            <TableHeaderSort
              header="Trade Date"
              sortParam="trade_date"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
              isActive={true}
              isDescending={true}
            />
          </th>
          <th style={{ width: "160px" }}>
            <TableHeaderSort
              header="Trade Amount"
              sortParam="trade_amount"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
            />
          </th>
          <th style={{ width: "160px" }}>
            <TableHeaderSort
              header="FX Amount"
              sortParam="fx_amount"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
            />
          </th>
          <th style={{ width: "110px" }}>
            <TableHeaderSort
              header="Exc. Rate"
              sortParam="exchange_rate"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
            />
          </th>
          <th style={{ width: "120px" }}>
            <TableHeaderSort
              header="Status"
              sortParam="status__name"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
            />
          </th>
          <th style={{ width: "80px" }}>
            <TableHeaderSort
              header="Notes"
              sortParam="notes_total"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
            />
          </th>
          <th style={{ width: "80px" }}>
            <TableHeaderSort
              header="Files"
              sortParam="files"
              sortData={(data) => tradeCtx.setSortArray([...data])}
              sortArray={tradeCtx.sortArray}
            />
          </th>
        </tr>
      </thead>
      <tbody>
        {tradeCtx.trades.length > 0 ? (
          tradeCtx.trades.map((t) => {
            return (
            <tr key={t.id}>
              <td>
                <input
                  type="checkbox"
                  checked={
                    tradeCtx.tradeBatch.find((lt) => lt == t.id) ? true : false
                  }
                  onChange={() =>
                    tradeCtx.setTradeBatch(
                      tradeCtx.tradeBatch.find((lt) => lt == t.id)
                        ? tradeCtx.tradeBatch.filter((lt) => lt !== t.id)
                        : tradeCtx.tradeBatch.concat(t.id)
                    )
                  }
                />
              </td>
              <td
                onClick={() => {
                  handleShowTrade(t);
                }}
              >
                {t.customer?.name}
              </td>
              <td
                onClick={() => {
                  handleShowTrade(t);
                }}
              >
                {t.bank.display_name}
              </td>
              <td
                onClick={() => {
                  handleShowTrade(t);
                }}
              >
                {t.trade_reference_number}
              </td>
              <td
                onClick={() => {
                  handleShowTrade(t);
                }}
              >
                {format(parseISO(t.trade_date), 'MM/dd/yyyy HH:mm')}
              </td>
              <td
                onClick={() => {
                  handleShowTrade(t);
                }}
              >{`R ${numberFormat(t.trade_amount)}`}</td>
              <td
                onClick={() => {
                  handleShowTrade(t);
                }}
              >
                {t.fx_currency.symbol} {numberFormat(t.fx_amount)}
              </td>
              <td
                onClick={() => {
                  handleShowTrade(t);
                }}
              >
                {t.trade_rate}
              </td>
              <td
                style={{ cursor: "pointer" }}
                onDoubleClick={() => {
                  tradeCtx.retryTrades([t.id]);
                }}
                className="statusTD"
              >
              
                  {handleTradeStatus(t)}
              
              </td>
              <td
                onClick={() => {
                  tradeCtx.setTrade(t);
                  tradeCtx.setShowNotes(true);
                }}
              >
                <FaStickyNote />
                <span className="notes-count"> {t.notes_total}</span>
              </td>
              <td
                onClick={() => {
                  
                  handleFileClicked(t);
                }}
              >
                <FaFile />
                <span className="notes-count"> {t.trade_documents.length}</span>
              </td>
            </tr>
          )})
        ) : (
          <tr>
            <td colSpan={40}>No trades found</td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

TradeTable.propTypes = {
  onChange: PropTypes.func,
};

export default TradeTable;
